import { call, put, select } from "redux-saga/effects";
import { howAppIsRunning, checkMocks } from "@/utils/commonUtils";
// import { PROD, nookInfoExchangeIds } from '@/constants/constants';
import { PROD } from "@/constants/constants";
import { actions as managerActions } from "@/reducers/manager";
import { allSettled } from "@/bit/sagas/utils.sagas.all-seatled";

import { actions } from "@/reducers/client";
import { actions as userActions } from "@/reducers/user";
import {
  getKeyToMediumContact,
  normalizeClientInfo,
  normalizeGetMyDataResponse,
  normalizeModifyContactMeans,
} from "@/sagas/normalizers/clientNormalizer";

import { handleSagaError } from "@/sagas/index";
import { handlingCodes } from "@/constants/constants";
import { checkFakeEmail } from "@/utils/utils";

export const transform2uppercase = (firstSurname, name) => {
  const nameCapitalized = name.charAt(0).toUpperCase() + name.slice(1);
  const surnameCapitalized =
    firstSurname.charAt(0).toUpperCase() + firstSurname.slice(1);
  return `${surnameCapitalized}, ${nameCapitalized}`;
};

const contextStore = (state) => state.main.context;
const foaStore = (state) => state.user.foa;

const getClientInfo = (state) => state.client.clientInfo;
const getAdditionalInfo = (state) => state.client.additionalInfo;
const getDebtPaymentFromState = (state) => state.client.debtPayment;

const FAKE_EMAIL = "Crea tu usuario";
export function* getClientData({ handlingCode = 0 }) {
  try {
    const MOCK_INFO = "getMyData";
    const context = yield select(contextStore);
    let clientInfo = yield select(getClientInfo);
    let additionalClientInfo = yield select(getAdditionalInfo);

    if (!clientInfo) {
      // yield put(actions.getClientData());
      let response = checkMocks(MOCK_INFO);
      if (response === null) {
        const module = yield call(() =>
          import("@/adabyron/telcol/client/get-my-data")
        );
        const promise = module.getMyData;
        response = yield call(promise, {
          context,
        });
      }
      clientInfo = normalizeClientInfo(
        normalizeGetMyDataResponse(response.datos)
      );
      if (clientInfo && clientInfo.firstSurname && clientInfo.name) {
        sessionStorage.setItem(
          "nameuser",
          transform2uppercase(clientInfo.firstSurname, clientInfo.name)
        );
        sessionStorage.setItem("urlhomeprivada", "tc");
      }
      if (howAppIsRunning() === PROD && clientInfo && clientInfo.xcol) {
        yield put(userActions.getegService(clientInfo.xcol));
      }

      if (!additionalClientInfo) {
        additionalClientInfo = response.additionalInfo;
      }

      yield put(
        actions.successGetClientData({
          clientInfo,
          additionalInfo: additionalClientInfo,
        })
      );
    }
  } catch (error) {
    yield actions.failureGetClientData(true);
    const reducerFailureAction = actions.failureGetClientData(true);
    yield handleSagaError(
      "getClientData",
      error,
      handlingCodes.FATAL,
      reducerFailureAction
    );
  }
}

export function* getEmailMPlus({ productId }) {
  try {
    const context = yield select(contextStore);
    const data = {
      productId,
    };
    const module = yield call(() =>
      import("@gcloud-npm/adabyron.client.datoscliente.misdatos.email")
    );
    const getEmailMovistarPlus = module.getEmailMovistarPlus;
    const response = yield call(getEmailMovistarPlus, {
      data,
      context,
    });
    if (response && response.datos && response.datos) {
      yield put(actions.successGetEmailMPlus(response.datos));
    }
  } catch (error) {
    const { response } = error;
    const reducerFailureAction = actions.failureGetEmailMPlus(response);
    yield handleSagaError(
      "getEmailMPlus",
      error,
      "ERROR",
      0,
      reducerFailureAction
    );
  }
  // getEmailMPlus
}

export function* getEmailsMPlus({ productIdList }) {
  try {
    const context = yield select(contextStore);
    let emailMPlusPromises = {};
    let normalizedResp = {};
    const module = yield call(() =>
      import("@gcloud-npm/adabyron.client.datoscliente.misdatos.email")
    );
    const getEmailMovistarPlus = module.getEmailMovistarPlus;
    productIdList.forEach((x) => {
      emailMPlusPromises[x.id] = {
        payload: {
          productId: x.id,
        },
        promise: getEmailMovistarPlus,
        ep: "getEmailMovistarPlus",
      };
    });

    const responsesConfig = yield call(allSettled, {
      promisesConfig: emailMPlusPromises,
      context,
    });
    responsesConfig.forEach((x) => {
      const finalMail = checkFakeEmail(x?.resp?.datos[0]?.email)
        ? FAKE_EMAIL
        : x?.resp?.datos[0]?.email;

      normalizedResp[x.payload.data.productId] = {
        id: x?.payload?.data?.productId,
        email: finalMail,
      };
    });

    yield put(actions.successGetEmailsMPlus(normalizedResp));
  } catch (error) {
    console.log(error);
    const { response } = error;
    const reducerFailureAction = actions.failureGetEmailsMPlus(response);
    yield handleSagaError(
      "getEmailsMPlus",
      error,
      "ERROR",
      0,
      reducerFailureAction
    );
  }
}

export function* getDebtPaymentData() {
  try {
    const debtPaymentAlreadyFetched = yield select(getDebtPaymentFromState);
    if (!debtPaymentAlreadyFetched) {
      let response = null;
      const context = yield select(contextStore);
      const foa = yield select(foaStore);
      const module = yield call(() =>
        import("@/adabyron/telcol/client/get-debet-payment")
      );
      const getDebtPayment = module.getDebtPayment;
      response = yield call(getDebtPayment, {
        context,
      });
      // const mock = {
      //   importe: '0',
      //   deuda: true,
      // }
      // const passwordRecovery = normalizePasswordRecovery(response);
      yield put(actions.successGetDebtPayment(response.datos));
    }
  } catch (error) {
    const reducerFailureAction = actions.failureGetDebtPayment(error);
    yield handleSagaError(
      "getDebtPaymentData",
      error,
      "ERROR",
      0,
      reducerFailureAction
    );
  }
}


export function* postModifyContactMeans(params) {
  try {
    const additionalInfo = yield select(getAdditionalInfo);
    const context = yield select(contextStore);

    const { mediumContacts } = params.payload;

    const mediumContactsTransformed = mediumContacts.reduce((acc, contact) => {
      const key = getKeyToMediumContact(contact);
      acc[key] = contact;

      return acc;
    }, {});

    const data = { ...mediumContactsTransformed, additionalInfo };

    const module = yield call(() =>
      import("@/adabyron/telcol/client/update")
    );
    const updateMyContacts = module.updateMyContacts;
    const response = yield call(updateMyContacts, {
      data,
      context,
    });

    if (response) {
      const modifyContactMeans = normalizeModifyContactMeans(mediumContacts);
      yield put(actions.successPostModifyContactMeans(modifyContactMeans));
    }
  } catch (error) {
    yield put(actions.failurePostModifyContactMeans(error));
  }
}

export function* changePassword(params) {
  try {
    const context = yield select(contextStore);
    const { newPassword } = params.payload
    const data = {
      newPassword,
    };
    const module = yield call(() =>
      import("@/adabyron/telcol/client/change-password")
    );
    const changePassword = module.changePassword;
    yield call(changePassword, {
      data,
      context,
    });
    yield put(actions.changePasswordSuccess());
  } catch (error) {
    const obj = {
      codigoErrorNegocio: '',
      descripcionErrorNegocio: '',
    }
    if (error.response && error.response.error) {
      obj.codigoErrorNegocio = error.response.error.codigoErrorNegocio
      obj.descripcionErrorNegocio = error.response.error.descripcionErrorNegocio
    }
    const reducerFailureAction = actions.changePasswordFailure(obj);
    yield put(actions.changePasswordFailure(obj))
  }
}
